// extracted by mini-css-extract-plugin
export default {"container":"privacidade_container__EEb+R","title":"privacidade_title__iJz8G"};